<div [ngClass]="['status-circle', `status-circle--${size()}`, `status-circle--${type()}`]">
  <i [ngClass]="['pi text-white status-icon-size', icon()]"></i>
</div>
